export default __webpack_public_path__ + "static/media/opensans-semibolditalic-webfont.58f32a1a.woff";